var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 10.5999V42.6599C23.66 42.6599 23.3 42.5999 23.02 42.4399L22.94 42.3999C19.1 40.2999 12.4 38.0999 8.06 37.5199L7.48 37.4399C5.56 37.1999 4 35.3999 4 33.4799V9.31989C4 6.93989 5.94 5.13989 8.32 5.33989C12.52 5.67989 18.88 7.79989 22.44 10.0199L22.94 10.3199C23.24 10.4999 23.62 10.5999 24 10.5999Z",
    fill: "url(#paint0_linear_150_33003)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 9.34006V33.4801C44 35.4001 42.44 37.2001 40.52 37.4401L39.86 37.5201C35.5 38.1001 28.78 40.3201 24.94 42.4401C24.68 42.6001 24.36 42.6601 24 42.6601V10.6001C24.38 10.6001 24.76 10.5001 25.06 10.3201L25.4 10.1001C28.96 7.86006 35.34 5.72006 39.54 5.36006H39.66C42.04 5.16006 44 6.94006 44 9.34006Z",
    fill: "url(#paint1_linear_150_33003)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.48H11C10.18 18.48 9.5 17.8 9.5 16.98C9.5 16.16 10.18 15.48 11 15.48H15.5C16.32 15.48 17 16.16 17 16.98C17 17.8 16.32 18.48 15.5 18.48Z",
    fill: "url(#paint2_linear_150_33003)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.48H11C10.18 24.48 9.5 23.8 9.5 22.98C9.5 22.16 10.18 21.48 11 21.48H17C17.82 21.48 18.5 22.16 18.5 22.98C18.5 23.8 17.82 24.48 17 24.48Z",
    fill: "url(#paint3_linear_150_33003)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_33003",
    x1: -8.9675,
    y1: 49.4155,
    x2: 50.3821,
    y2: 20.4898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_33003",
    x1: 11.0325,
    y1: 49.4121,
    x2: 70.37,
    y2: 20.4769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_33003",
    x1: 4.63719,
    y1: 19.0228,
    x2: 9.09859,
    y2: 8.87514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_33003",
    x1: 3.66463,
    y1: 25.0228,
    x2: 7.57605,
    y2: 14.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.f339fad82ecdfc1ad253634ba99f7f98.svg";
export { ForwardRef as ReactComponent };